import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import "./office-ui-fabric-setup";
import App from "./App";
import "./index.css";
ReactDOM.render(_jsx(App, {}, void 0), document.getElementById("root"));
